import { enumToOptions } from '@app/shared/helpers';
import { SponsorInvestmentStructure } from '@app/shared/models/contracts/enums/shared-enums';
import { l, translationKeys } from '@locale/setupI18n';

export const getSponsorInvestmentOptions = () =>
  enumToOptions(SponsorInvestmentStructure, undefined, true).map((o) => ({
    viewValue: l(o.viewValue as translationKeys),
    vallue: o.value,
  }));
